import React from 'react';
import PropTypes from 'prop-types';
import { FONTS } from '../../constants/Fonts';
import './RapFireQuestionIndexBadge.css';

/**
 * Figma 18423:5094 / 18423:5096 — question index circle (1/5).
 */
const RapFireQuestionIndexBadge = ({ current = 1, total = 5 }) => (
  <span
    className="rf-q-index"
    data-node-id="18423:5096"
    aria-label={`Question ${current} of ${total}`}
    style={{ fontFamily: FONTS.INTER_MEDIUM }}
  >
    {`${current}/${total}`}
  </span>
);

RapFireQuestionIndexBadge.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
};

export default RapFireQuestionIndexBadge;
